import React from "react";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

function SectionHeader({ pageHeader }) {
  return (
    <div className="shadeBg">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center mt-4 mb-4">
          <br />
          <br />
          <h3>{pageHeader.subtitle}</h3>
          <h1 className="text-renonLite">{pageHeader.title}</h1>
        </div>

        <Row className="justify-content-center text-center mt-4 mb-4">
          <Col xs={12} md={12} lg={8} xl={8}>
            {pageHeader.description}
            <br />
            {pageHeader.details}
          </Col>
        </Row>
      </motion.div>
    </div>
  );
}

export default SectionHeader;
